// +----------------------------------------------------------------------
// | TITA 扩展：店铺会员路由（对齐 CRMEB_MER_v4.2 mer router/modules/member.js）
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router';
import { roterPre } from '@/settings';

const memberRouter: RouteRecordRaw = {
  path: `${roterPre}/member`,
  name: 'member',
  meta: { icon: 'peoples', title: '会员' },
  alwaysShow: true,
  component: Layout,
  redirect: 'noRedirect',
  children: [
    {
      path: 'overview',
      name: 'MemberOverview',
      meta: { title: '会员概览', noCache: true },
      component: () => import('@/views/member/overview/index.vue'),
    },
    {
      path: 'customer',
      name: 'CustomerList',
      meta: { title: '会员列表', noCache: true },
      component: () => import('@/views/member/customerList/index.vue'),
    },
    {
      path: 'customer/detail/:uid',
      name: 'CustomerDetail',
      meta: { title: '会员详情', activeMenu: `${roterPre}/member/customer`, noCache: true },
      component: () => import('@/views/member/customerList/detail.vue'),
      hidden: true,
    },
    {
      path: 'benefits',
      name: 'MemberBenefits',
      meta: { title: '会员权益', noCache: true },
      component: () => import('@/views/member/benefits/index.vue'),
    },
    {
      path: 'agreement',
      name: 'MemberAgreement',
      meta: { title: '会员协议', noCache: true },
      component: () => import('@/views/member/agreement/index.vue'),
    },
    {
      path: 'level',
      name: 'MemberLevel',
      meta: { title: '会员等级', noCache: true },
      component: () => import('@/views/member/level/index.vue'),
    },
    {
      path: 'level/add',
      name: 'MemberLevelAdd',
      meta: { title: '添加会员等级', activeMenu: `${roterPre}/member/level`, noCache: true },
      component: () => import('@/views/member/level/add.vue'),
      hidden: true,
    },
    {
      path: 'level/edit/:id',
      name: 'MemberLevelEdit',
      meta: { title: '编辑会员等级', activeMenu: `${roterPre}/member/level`, noCache: true },
      component: () => import('@/views/member/level/add.vue'),
      hidden: true,
    },
    {
      path: 'recharge',
      name: 'RechargePackage',
      meta: { title: '充值套餐', noCache: true },
      component: () => import('@/views/member/recharge/index.vue'),
    },
    {
      path: 'recharge/add',
      name: 'RechargePackageAdd',
      meta: { title: '添加充值套餐', activeMenu: `${roterPre}/member/recharge`, noCache: true },
      component: () => import('@/views/member/recharge/add.vue'),
      hidden: true,
    },
    {
      path: 'recharge/edit/:id',
      name: 'RechargePackageEdit',
      meta: { title: '编辑充值套餐', activeMenu: `${roterPre}/member/recharge`, noCache: true },
      component: () => import('@/views/member/recharge/add.vue'),
      hidden: true,
    },
    {
      path: 'recharge/order',
      name: 'ShoppingCreditsOrder',
      meta: { title: '充值订单', noCache: true },
      component: () => import('@/views/member/recharge/order.vue'),
    },
    {
      path: 'recharge/refund',
      name: 'ShoppingCreditsRefund',
      meta: { title: '退款订单', noCache: true },
      component: () => import('@/views/member/recharge/refund.vue'),
    },
  ],
};

export default memberRouter;
